import { sortByKey } from '../../utils/array'
import {
  CARD_ADD_SUCCESS,
  CARD_PATCH_SUCCESS,
  CARD_MEDIA_ADD_SUCCESS,
  CARD_MEDIA_DELETE_SUCCESS,
  CARD_LINK_ADD_SUCCESS,
  CARD_SELECTION_ADD_SUCCESS,
  CARD_LINK_DELETE_SUCCESS,
  CARD_SELECTION_DELETE_SUCCESS,
  CARD_SELECTION_PATCH_SUCCESS,
  COURSE_REMOVE_CARD_SUCCESS,
  CARD_SETTING_CREATE_SUCCESS,
  CARD_SETTING_PATCH_SUCCESS,
  CARD_SETTING_REMOVE,
  COURSE_CARD_LINK_PATCH_SUCCESS,
  CARD_CHANGE_IMAGE,
  GET_CARD_SUCCESS,
  EDITOR_LOADING,
} from './type'
import {
  QuestionLinkSchema,
  QuestionFieldNames,
  QuestionMediaSchema,
  SelectionSchema,
} from '../../model/card'
//eslint-disable-next-line
export default function (
  state = {
    currentCard: null,
    editorLoading: false,
    editorError: false,
  },
  action,
) {
  const { payload, type } = action

  switch (type) {
    case COURSE_REMOVE_CARD_SUCCESS:
      return state
    case CARD_SETTING_CREATE_SUCCESS:
      state = {
        ...state,
        currentCard: {
          ...state.currentCard,
          settingDtos: [...state.currentCard.settingDtos, payload.content],
        },
      }
      return state
    case CARD_SETTING_REMOVE:
      state = {
        ...state,
        entity: {
          ...state.entity,
          cardDtos: [
            ...state.entity.cardDtos.map((q, i) => {
              if (q.id === payload.questionId) {
                return {
                  ...q,
                  [QuestionFieldNames.SETTING_DTOS]: [
                    ...state.entity.cardDtos[i][
                      QuestionFieldNames.SETTING_DTOS
                    ].filter(v => v.id != payload.id),
                  ],
                }
              }
              return q
            }),
          ],
        },
      }
      return state
    case CARD_SETTING_PATCH_SUCCESS:
      state = {
        ...state,
        currentCard: {
          ...state.currentCard,
          settingDtos: [
            ...state.currentCard.settingDtos.map((value, index) => {
              if (value.id === payload.settingId) {
                return {
                  ...value,
                  value: payload.content.value,
                }
              }
              return value
            }),
          ],
        },
      }
      return state

    case CARD_PATCH_SUCCESS:
      let newPaths = {}
      payload.content.contents.forEach(patchContent => {
        newPaths = { ...newPaths, [patchContent.path]: patchContent.value }
      })
      state = {
        ...state,
        currentCard: {
          ...state.currentCard,
          ...newPaths,
        },
      }
      return state
    case CARD_SELECTION_DELETE_SUCCESS:
      state = {
        ...state,
        currentCard: {
          ...state.currentCard,
          [QuestionFieldNames.SELECTIONS]: [
            ...state.currentCard[QuestionFieldNames.SELECTIONS].filter(
              s => s.id !== payload.id,
            ),
          ],
        },
      }

      return state
    case CARD_ADD_SUCCESS:
      return {
        ...state,
        entity: {
          ...state.entity,
          ...payload.entity,
        },
      }

    case CARD_MEDIA_ADD_SUCCESS:
      const mediaSchema = { ...QuestionMediaSchema(), ...payload.entity }

      return {
        ...state,
        currentCard: {
          ...state.currentCard,
          [QuestionFieldNames.QUESTION_MEDIAS]: [{ ...mediaSchema }],
        },
      }

    case CARD_MEDIA_DELETE_SUCCESS:
      return {
        ...state,
        currentCard: {
          ...state.currentCard,
          [QuestionFieldNames.QUESTION_MEDIAS]: state.currentCard[
            QuestionFieldNames.QUESTION_MEDIAS
          ].filter(function (item) {
            return item.id !== payload.id
          }),
        },
      }
    case CARD_LINK_ADD_SUCCESS:
      const linkSchema = { ...QuestionLinkSchema(), ...payload.entity }
      const linkList = state.entity[QuestionFieldNames.QUESTION_LINKS]
        ? [...state.entity[QuestionFieldNames.QUESTION_LINKS]]
        : []
      return {
        ...state,
        entity: {
          ...state.entity,
          [QuestionFieldNames.QUESTION_LINKS]: [
            ...sortByKey([...linkList, { ...linkSchema }], 'title'),
          ],
        },
      }

    case CARD_SELECTION_ADD_SUCCESS:
      if (state.currentCard == null) {
        return state
      }

      const selectionData = { ...SelectionSchema(), ...payload.response }

      const selectionList = state.currentCard[QuestionFieldNames.SELECTIONS]
        ? [...state.currentCard[QuestionFieldNames.SELECTIONS]]
        : []

      return {
        ...state,
        currentCard: {
          ...state.currentCard,
          [QuestionFieldNames.SELECTIONS]: [
            ...sortByKey([...selectionList, { ...selectionData }], 'id'),
          ],
        },
      }

    case CARD_SELECTION_PATCH_SUCCESS:
      let selectionIdForPatch = payload.content.id
      let newPaths2 = {}

      payload.content.contents.forEach(patchContent => {
        newPaths2 = { ...newPaths2, [patchContent.path]: patchContent.value }
      })

      state = {
        ...state,
        currentCard: {
          ...state.currentCard,
          [QuestionFieldNames.SELECTIONS]: [
            ...state.currentCard[QuestionFieldNames.SELECTIONS].map(s => {
              if (s.id == selectionIdForPatch) {
                return {
                  ...s,
                  ...newPaths2,
                }
              }
              return s
            }),
          ],
        },
      }
      return state

    case CARD_LINK_DELETE_SUCCESS:
      let questionIdForPatch5 = payload.questionId
      state = {
        ...state,
        entity: {
          ...state.entity,
          cardDtos: [
            ...state.entity.cardDtos.map(q => {
              if (q.id == questionIdForPatch5) {
                return {
                  ...q,
                  [QuestionFieldNames.QUESTION_LINKS]: q[
                    QuestionFieldNames.QUESTION_LINKS
                  ].filter(function (item) {
                    return item.id !== payload.id
                  }),
                }
              }
              return q
            }),
          ],
        },
      }
      return state
    case COURSE_CARD_LINK_PATCH_SUCCESS:
      let linkIdForPatch = payload.content.id
      let newPaths3 = {}

      payload.content.contents.forEach(patchContent => {
        newPaths3 = { ...newPaths3, [patchContent.path]: patchContent.value }
      })

      state = {
        ...state,
        currentCard: {
          ...state.currentCard,
          [QuestionFieldNames.QUESTION_LINKS]: [
            ...state.currentCard[QuestionFieldNames.QUESTION_LINKS].map(s => {
              if (s.id == linkIdForPatch) {
                return {
                  ...s,
                  ...newPaths3,
                }
              }
              return s
            }),
          ],
        },
      }
      return state
    case CARD_CHANGE_IMAGE:
      state = {
        ...state,
        entity: {
          ...state.entity,
          cardDtos: [
            ...state.entity.cardDtos.map(q => {
              if (q.id === payload.cardId) {
                return {
                  ...q,
                  mediaDtos: [
                    ...q.mediaDtos.map(m => {
                      return {
                        ...m,
                        mediaUrl: payload.imageUrl,
                      }
                    }),
                  ],
                }
              }
              return q
            }),
          ],
        },
      }
      return state

    case GET_CARD_SUCCESS:
      return {
        ...state,
        currentCard: payload.response == null ? null : payload.response.data,
      }
    case EDITOR_LOADING:
      const errorState = payload.error ? payload.error : false
      return {
        ...state,
        editorLoading: !state.editorLoading,
        editorError: errorState,
      }
    /* case DELETE_SECTION_SUCCESS:
        return {
          ...state,

        } */
    default:
      return state
  }
}
